import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class VisionStepPerimeterCriteria extends BasicCriteria {
visionCode: string;
visionStepLevel: number | null;
}

